import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import FooterComponent from '../footer';
import HeaderComponent from '../header';

const MainLayoutComponent = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showFooter, setShowFooter] = useState(false);
  const location = useLocation();
  const checkIfMobile = () => {
    const becameMobile = window.innerWidth <= 768;
    if (isMobile !== becameMobile) {
      setIsMobile(becameMobile);
    }
  };
  useEffect(() => {
    if (location.pathname === '/privacy-policy' || location.pathname === '/tandc') {
      setShowFooter(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', checkIfMobile);
  }, [isMobile]);

  return (
    <div className="container-fluid">
      {!isMobile && (
        <div className="row">
          <div className="col-12">
            <HeaderComponent />
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12 p-0">
          <Outlet />
        </div>
      </div>
      {!showFooter && (
        <div className="row">
          <div className="col-12">
            <FooterComponent />
          </div>
        </div>
      )}
    </div>
  );
};

export default MainLayoutComponent;
